module.exports = __webpack_public_path__ + "dc0587781147931f7fa7e422d8e097cd.png";